import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import ObserverEmitter, { EVENTS } from '../../../emitter/Observer';
import { audiosAssets } from '../../../assets/audio';
import { ButtonHome } from '../../../components/common/ButtonHome';
import { ButtonPlay } from '../../../components/common/ButtonPlay';
import { HeaderRedPresentation } from '../../../components/common/HeaderRedPresentation';
import { DialogBarNew } from '../../../components/common/DialogBarNew';
import { PanelActivities } from '../../../components/common/PanelActivities';
import { BarStatusActivies } from '../../../components/common/BarStatusActivies';
import { ValidationResultModal } from '../../../components/common/ValidationResultModal';
import { useNavigate } from 'react-router-dom';
import { completeOneTask } from '../../../store/slices/menu/tunks';
import { tasksId } from '../../../types/activityTasks';
import { useGetActivitiesBySubTopic } from '../../../hooks/useGetActivitiesBySubTopic';
import { imgTema6 } from '../../../assets/tema6';
import { voicesTypeControl } from '../../../types/audioType';
import { ButtonReturn } from '../../../components/common/ButtonReturn';

const steps = {
	dialogInitial: 1,
	panelActivities: 2,
	dialogTwo: 3,
	dialogThree: 4,
	dialogFour: 5,
	dialogFive: 6,
	dialogSix: 7,
	dialogSeven: 8,
	dialogEight: 9,
	dialogNine: 10,
	dialogTen: 11,
	dialogEleven: 12,
	dialogTwelve: 13,
	win: 14,
	hideUI: 20
};

const stepThree = {
	move_desktop: {
		ui: steps.dialogEleven,
		action: () => {
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T6.sub04.sub4_act2_a11)
		}
	},
}

export const Theme6SubtopicFourActivityTwo = () => {
	const navigator = useNavigate()
	const dispatch = useDispatch()
	const { loaded, activitiesInformation } = useSelector((state) => state.menu);
	const { tasksList, points } = useGetActivitiesBySubTopic(activitiesInformation[tasksId.tema6.activities.subtema4], 2);
	const [uiToShow, setUiToShow] = useState(steps.dialogInitial);

	useEffect(() => {
		if (loaded) {
			console.log("theme 6 sub 4 act 2");
			ObserverEmitter.emit(EVENTS.tema6.topic4.initScene, 2);
			ObserverEmitter.emit(EVENTS.audiosEvents.pauseActive, true)
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioScene, audiosAssets.escenarios.onOxxoScene)
		}
	}, [loaded]);

	ObserverEmitter.on(EVENTS.audioInitByTopic, () => {
		ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T6.sub04.sub4_act2_a01)
	})

	ObserverEmitter.on(EVENTS.tema6.topic4.listenScene, (step = "") => {
		const valuesObj = stepThree[step]
		if (!valuesObj) {
			return
		}
		valuesObj.action()
		setUiToShow(valuesObj.ui)
	})

	return (
		<>
			<>
				<ButtonPlay />
				<ButtonHome />
				{![1, 20].includes(uiToShow) && (
					<ButtonReturn callback={() => {
						ObserverEmitter.emit(EVENTS.tema6.topic4.initScene, 2);
						ObserverEmitter.emit(EVENTS.tema6.topic4.actScene, "move_desk");
						setUiToShow(1)
					}} />
				)}
			</>

			{uiToShow === steps.dialogInitial && (
				<>
					<HeaderRedPresentation name="Actividad 2: Simulación con cliente." />
					<DialogBarNew
						dialog={`¡Ahí viene un Cliente! Es momento de poner a prueba lo que hemos visto.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.characterAnimations.hiddenModel);
							setUiToShow(steps.panelActivities);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.panelActivities && (
				<>
					<PanelActivities
						buttonText="¡Comenzar!"
						title="Subtema 4. OXXO Pay"
						titleActivity="Actividades por realizar:"
						points={points}
						insigniaBackground={0}
						actionButton={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T6.sub04.sub4_act2_a02)
							ObserverEmitter.emit(EVENTS.tema6.topic4.actScene, "move_client_1");
							setUiToShow(steps.dialogTwo);
						}}
						activities={tasksList}
					/>
				</>
			)}

			{uiToShow === steps.dialogTwo && (
				<>
					<BarStatusActivies
						activities={tasksList}
					/>
					<ViewPerson img={imgTema6.Yonny_saludo} />
					<DialogBarNew
						name='Yonny'
						dialog={`Buen día, he venido a realizar un pago de Mercado Libre.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T6.sub04.sub4_act2_a03)
							setUiToShow(steps.dialogThree);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogThree && (
				<>
					<ViewPerson img={imgTema6.Anahi_feliz} />
					<DialogBarNew
						name='Anahí'
						dialog={`¡Con todo gusto! Se cobrarían $15 pesos de comisión.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T6.sub04.sub4_act2_a04)
							setUiToShow(steps.dialogFour);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogFour && (
				<>
					<ViewPerson img={imgTema6.Yonny_tranqui} />
					<DialogBarNew
						name='Yonny'
						dialog={`Sin problema.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T6.sub04.sub4_act2_a05)
							setUiToShow(steps.dialogFive);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogFive && (
				<>
					<ViewPerson img={imgTema6.Anahi_feliz} />
					<DialogBarNew
						name='Anahí'
						dialog={`¿Podría compartirme su número de referencia?`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T6.sub04.sub4_act2_a06)
							setUiToShow(steps.dialogSix);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogSix && (
				<>
					<ViewPerson img={imgTema6.Yonny_tranqui} />
					<DialogBarNew
						name='Yonny'
						dialog={`Si, es el 83 20 20 20.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T6.sub04.sub4_act2_a07)
							setUiToShow(steps.dialogSeven);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogSeven && (
				<>
					<ViewPerson img={imgTema6.Anahi_feliz} />
					<DialogBarNew
						name='Anahí'
						dialog={`¿Podría por favor repetirme su número de referencia?`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T6.sub04.sub4_act2_a08)
							setUiToShow(steps.dialogEight);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogEight && (
				<>
					<ViewPerson img={imgTema6.Yonny_tranqui} />
					<DialogBarNew
						name='Yonny'
						dialog={`Si, es el 9300 0000 928 82.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T6.sub04.sub4_act2_a09)
							setUiToShow(steps.dialogNine);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogNine && (
				<>
					<ViewPerson img={imgTema6.Anahi_feliz} />
					<DialogBarNew
						name='Anahí'
						dialog={`Sería un total de $35 pesos, ¿pagaría con efectivo o con tarjeta?`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T6.sub04.sub4_act2_a10)
							setUiToShow(steps.dialogTen);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogTen && (
				<>
					<ViewPerson img={imgTema6.Yonny_tarjeta} />
					<DialogBarNew
						name='Yonny'
						dialog={`Con tarjeta por favor.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.tema6.topic4.actScene, "view_animation");
							setUiToShow(steps.hideUI);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogEleven && (
				<>
					<DialogBarNew
						dialog={`Selecciona la tecla “T” cuando se realice un pago con tarjeta.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T6.sub04.sub4_act2_a12)
							setUiToShow(steps.dialogTwelve);
							ObserverEmitter.emit(EVENTS.tema6.topic4.actScene, "move_client_2");
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogTwelve && (
				<>
					<ViewPerson img={imgTema6.Anahi_ticket} />
					<DialogBarNew
						name='Anahí'
						dialog={`Ya puede retirar su tarjeta le entrego su ticket, lo esperamos con gusto en su siguiente visita.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.tema6.topic4.actScene, "move_desk");
							setUiToShow(steps.win);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.hideUI && (
				<>

				</>
			)}


			{uiToShow === steps.win && (
				<>
					<ValidationResultModal
						title="¡Bien hecho!"
						numberPoints={0}
						dialogModal="Has completado otra actividad con éxito. Sigue así, ¡tu esfuerzo y dedicación son admirables!"
						buttonTxt="Continuar"
						isCorrect={true}
						action={() => {
							dispatch(
								completeOneTask({
									idActivity: 2,
									pointsWin: 0,
									subtema: tasksId.tema6.activities.subtema4
								})
							);
							navigator("/home6/tema6/subtema4/activityThree");
						}}
					/>
				</>
			)}
		</>
	)
}


const ViewPerson = ({ img = "" }) => {
	return (
		<>
			<div className='fixed h-full w-full bg-[#00000074] flex justify-center items-center'>
				<div className='w-[250px] h-[250px] md:w-[500px] md:h-[500px]'>
					<img className='h-full w-full object-contain' src={img} alt="person" />
				</div>
			</div>
		</>
	)
}